import Vue from "@/main";
import { Message } from "element-ui";

export let graphicLayer; // 矢量图层对象
let rPColor = "#ffd700";
let iurl = "/img/marker/mark" + rPColor.slice(1) + ".png";

import { BimViewPntsGroupingDetail } from "@/api/api";

export function createdGraphicLayer() {
  graphicLayer = new mars3d.layer.GraphicLayer();
  Vue.$GLOBAL.map.addLayer(graphicLayer);
}

export function openPath(arr) {
  if (graphicLayer) graphicLayer.clear();
  let list = [];
  arr.forEach((el, index) => {
    list.push([el.detail.lng, el.detail.lat, el.detail.alt]);
    console.log(index);
    addDemoGraphic(el.detail.lng, el.detail.lat, el.detail.alt, index);
  });
  const graphic = new mars3d.graphic.PolylineEntity({
    positions: list,
    // style: {
    //   width: 5,
    //   color: "#3388ff",
    //   clampToGround: false,
    //   // materialType: mars3d.MaterialType.LineFlow,
    //   // materialOptions: {
    //   //   color: Cesium.Color.CHARTREUSE,
    //   //   image: "/img/textures/lineClr.png",
    //   //   speed: 15,
    //   // },
    // },
    style: {
      width: 7,
      // 动画线材质
      material: mars3d.MaterialUtil.createMaterialProperty(
        mars3d.MaterialType.LineFlow,
        {
          color: "#ff0000",
          image: "/img/textures/lineAarrow.png",
          speed: 20,
          repeat: new Cesium.Cartesian2(5, 1),
        }
      ),
      show: true,
      depthFail: true,
      depthFailColor: "#ff0000",
      depthFailMaterial: mars3d.MaterialUtil.createMaterialProperty(
        mars3d.MaterialType.LineFlow,
        {
          color: "#ff0000",
          image: "/img/textures/lineAarrow.png",
          speed: 20,
          repeat: new Cesium.Cartesian2(5, 1),
        }
      ),
    },
  });
  graphicLayer.addGraphic(graphic);
}

function addDemoGraphic(lng, lat, alt, i) {
  // const graphic = new mars3d.graphic.PointEntity({
  //   name: "",
  //   position: new mars3d.LngLatPoint(lng, lat, alt),
  //   style: {
  //     color: "red",
  //     pixelSize: 20,
  //     scaleByDistance: new Cesium.NearFarScalar(10000, 1.0, 500000, 0.1),
  //   },
  // });
  // graphicLayer.addGraphic(graphic);

  const graphic = new mars3d.graphic.BillboardEntity({
    position: new mars3d.LngLatPoint(lng, lat, alt),
    style: {
      image: iurl,

      scale: 0.5,

      outline: true,
      outlineColor: "#000000",
      outlineWidth: 2,
      horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      visibleDepth: false,
      label: {
        text: i + 1,
        font_size: 20,
        font_family: "楷体",
        color: "#ffff00",
        pixelOffsetY: -35,
        distanceDisplayCondition: true,
        distanceDisplayCondition_far: 500000,
        distanceDisplayCondition_near: 0,
      },
    },
  });
  graphicLayer.addGraphic(graphic);

  // layerPoints.hasEdit = true;
  // let tempGL = layerPoints.startDraw({
  //   type: "billboard",
  //   style: {
  //     image: iurl,
  //     scale: 1,
  //     scaleByDistance_farValue: 0.2,
  //     scaleByDistance_far: 100000,
  //     scaleByDistance_near: 100,
  //     scaleByDistance_nearValue: 0.5,
  //     scaleByDistance: true,
  //     label: {
  //       //不需要文字时，去掉label配置即可
  //       text: label.toString(),
  //       font_size: 26,
  //       font_family: "黑体",
  //       color: rPColor,
  //       outline: true,
  //       pixelOffsetY: -35,
  //       visibleDepth: false,
  //       distanceDisplayCondition: true,
  //       distanceDisplayCondition_far: 10000,
  //       distanceDisplayCondition_near: 0,
  //     },
  //     visibleDepth: false,
  //     horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
  //     verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
  //     //clampToGround: true, //贴地
  //   },
  //   success: function(e) {

  //   },
  // });
}

export function clearPath() {
  if (graphicLayer) graphicLayer.clear();
}
export function showPath(type) {
  graphicLayer.setOptions({ show: type });
}

export function handleCustomRoaming(type, id) {
  BimViewPntsGroupingDetail({
    projectId: window.sessionStorage.getItem("nowProjectId"),
  })
    .then((res) => {
      if (res.data.code == 200) {
        res.data.data.forEach((el) => {
          if (el.id == id) {
            openSimulation(el);
          }
        });
      }
    })
    .catch((err) => {});
}

let initialIndex = 0;
let contrastTime = null;
let shidianArr = [];
let setTimeouts = null;
let setIntervals = null;
function openSimulation(e) {
  if (!e.children.length) return;
  Vue.$GLOBAL.map.setCameraView(
    {
      lat: e.children[0].detail.lat,
      lng: e.children[0].detail.lng,
      alt: e.children[0].detail.alt,
      heading: e.children[0].detail.heading,
      pitch: e.children[0].detail.pitch,
    },
    {
      complete: function() {
        // showPath(false);
        initialIndex = 0;
        let roamSpeed;
        if (e.isGlobal) {
          //打开了方案全局速度
          roamSpeed = e.roamSpeed ? e.roamSpeed : e.customSpeed;
        }
        // Message({
        //   message: "方案速度未选择!",
        //   type: "warning",
        // });
        // return;

        contrastTime = roamSpeed * 1000;
        let arr = [];
        e.children.forEach((el) => {
          if (!e.isGlobal) {
            // 8是默认中等速度
            roamSpeed = el.viewPointLastingTime ? el.viewPointLastingTime : 8;
          }
          arr.push({
            lng: el.detail.lng,
            lat: el.detail.lat,
            alt: el.detail.alt,
            heading: el.detail.heading,
            pitch: el.detail.pitch,
            duration: roamSpeed,
            stop: 0,
            onEnd: () => {
              initialIndex += 1;
              // 重新计算时间
              contrastTime = roamSpeed * 1000;
            },
          });
        });
        shidianArr = arr;
        arr[0].stop = 1;
        Vue.$GLOBAL.map.setCameraViewList(arr, {
          maximumHeight: 10,
          complete: () => {
            Message({
              type: "success",
              message: "视点播放完毕",
            });
            // showPath(true);
            clearInterval(setTimeouts);
            clearInterval(setIntervals);
          },
        });
        let judgment = false;

        setTimeouts = setInterval(() => {
          contrastTime = contrastTime - 100;
        }, 100);
        // this.$once("hook:beforeDestroy", () => {
        //   clearInterval(setTimeouts);
        //   clearInterval(setIntervals);
        // });
        document.onkeydown = (e) => {
          let key = window.event.keyCode;
          if (key == 32) {
            // 空格
            if (judgment) {
              if (shidianArr.length) {
                let arr = shidianArr.slice(initialIndex, shidianArr.length);
                if (arr.length) {
                  arr[0].duration = contrastTime / 1000;
                  setTimeouts = setInterval(() => {
                    contrastTime =
                      contrastTime > 100 ? contrastTime - 100 : contrastTime;
                  }, 100);
                  Vue.$GLOBAL.map.setCameraViewList(arr, {
                    maximumHeight: 10,
                    complete: () => {
                      Message({
                        type: "success",
                        message: "视点播放完毕",
                      });
                      // showPath(true);
                      clearInterval(setTimeouts);
                      clearInterval(setIntervals);
                    },
                  });
                }
              }
            } else {
              // 暂停
              clearInterval(setTimeouts);
              clearInterval(setIntervals);

              Vue.$GLOBAL.map.cancelFlyTo();
            }
            judgment = !judgment;
          }
          if (key == 27) {
            // Esc
            if (setTimeouts) {
              clearInterval(setTimeouts);
              clearInterval(setIntervals);
              setTimeouts = null;
              Vue.$GLOBAL.map.cancelFlyTo();
              initialIndex = 0;
              shidianArr = [];
              Message({
                type: "success",
                message: "退出视点漫游!",
              });
            }
            // showPath(true);
          }
        };
      },
    }
  );
}
